import { NgIf, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  Input,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { DropdownComponent } from '../../../common/dropdown/dropdown.component';
import { FocusTrap, FocusTrapFactory } from '../../../core/a11y/focus-trap';

@Component({
  selector: 'rt-select-dropdown',
  templateUrl: './select-dropdown.component.html',
  styleUrls: ['./select-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DropdownComponent, NgTemplateOutlet, NgIf],
})
export class SelectDropdownComponent {
  @Input() public width?: number | null;
  @Input() public minWidth: number | 'max-content' | null | undefined = null;
  @Input() public maxWidth: number | null | undefined = null;
  @Input() public noMaxHeight: boolean = false;
  @Input() public hasStickyFooter: boolean = false;
  @Input() public scrollTop: number = 0;
  @Input() public footerTemplate?: TemplateRef<any>;
  @Input() public footerTemplateContext?: Record<string, any> = {};

  // TODO Why is it like this?
  @ContentChild(TemplateRef, { static: true }) public template: TemplateRef<any>;
  @ViewChild('rtDropdown', { static: true, read: ElementRef }) public rtDropdown: ElementRef;

  private _focusTrap: FocusTrap;

  constructor(
    private elRef: ElementRef,
    private cdRef: ChangeDetectorRef,
    private _focusTrapFactory: FocusTrapFactory,
  ) {}

  public ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  public ngAfterViewInit(): void {
    if (!this._focusTrap) {
      this._focusTrap = this._focusTrapFactory.create(this.elRef.nativeElement);
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.scrollTop && this.rtDropdown && this.rtDropdown.nativeElement) {
      this.rtDropdown.nativeElement.firstElementChild.scrollTop = changes.scrollTop.currentValue;
    }
  }

  public ngOnDestroy(): void {
    if (this._focusTrap) {
      setTimeout(() => {
        this._focusTrap.destroy();
      }, 0);
    }
  }

  public get minWidthAttr() {
    return typeof this.minWidth === 'number' ? this.minWidth + 'px' : this.minWidth;
  }
}
